<template>
  <section class="content">
    <BlockUI v-show="loadingShow">
      <div class="spinner-border text-info"></div>
      <p>شکیبا باشید...</p>
    </BlockUI>
    <div class="body_scroll">
      <div class="block-header">
        <div class="row">
          <div class="col-lg-7 col-md-6 col-sm-12">
            <h2>مدیریت باشگاه مشتریان</h2>
            <ul class="breadcrumb mt-3">
              <li class="breadcrumb-item">
                <a href="Dashboard">
                  <i class="zmdi zmdi-home"></i>پنل مدیریت
                </a>
              </li>

              <li class="breadcrumb-item active">
                <a href="#" @click="getScores">مدیریت باشگاه مشتریان</a>
              </li>
              <!--              <li class="breadcrumb-item active">
                              <a href="#" ref="BreadCrumbTitle">
                                سفارش گذاری
                              </a>
                            </li>-->
            </ul>
            <button class="btn btn-primary btn-icon mobile_menu" type="button">
              <i class="zmdi zmdi-sort-amount-desc"></i>
            </button>
          </div>
          <div class="col-lg-5 col-md-6 col-sm-12 text-left">
            <!--            <button class="btn btn-primary float-right right_icon_toggle_btn" type="button">
                          <i class="zmdi zmdi-arrow-right align-middle"></i>
                        </button>-->
            <!--            <div class="dropdown float-left">
                          <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                            دسترسی
                            <i class="zmdi zmdi-caret-down" style="vertical-align:middle;"></i>
                          </button>
                          <div class="dropdown-menu">
                            <a class="dropdown-item" href="#" @click="panelActive='ProductionPlanningDashboard'">برنامه ریزی
                              تولید</a>
                            <a class="dropdown-item" href="#" @click="panelActive='OrderingDashboard'">سفارش گذاری</a>
                            <a class="dropdown-item" href="#" @click="panelActive='InspectorsDashboard'">بازرسی</a>
                            <a class="dropdown-item" href="#" @click="panelActive='LogisticsDashboard'">شناسنامه ارسال محموله</a>
                            <a class="dropdown-item" href="#" @click="panelActive='ShipmentDashboard'">کارتابل ارسال محموله</a>
                          </div>
                        </div>-->
            <button
                class="btn btn-success float-right right_icon_toggle_btn"
                type="button"
                title="لیست سیاه"
                data-color="red"
                data-toggle="modal"
                @click="openBlockListModal">
              لیست سفید محاسبه
            </button>
            <button
                class="btn btn-success"
                type="button"
                title="امتیاز دستی"
                data-color="red"
                data-toggle="modal"
                @click="openAddManualScoreModal">
              افزایش امتیاز دستی
            </button>
            <!--            <button
                            class="btn btn-success float-right right_icon_toggle_btn"
                            type="button"
                            title="دانلود PDF لیست فروشگاه ها"
                            data-color="red"
                            data-toggle="modal"
                            @click="downloadShopList()"
                        >
                          <i class="zmdi zmdi-download align-middle"></i>
                          دانلود PDF لیست فروشگاه‌ها
                        </button>-->
            <!--            <button class="btn btn-primary float-right right_icon_toggle_btn" type="button"
                                @click="openNewContractModal">
                          قرارداد جدید
                        </button>-->
            <!--            <button class="btn btn-primary float-right right_icon_toggle_btn" type="button"
                                @click="openFindCustomerModal">
                          فیلتر گذاری
                        </button>-->
          </div>
        </div>
      </div>

      <div class="container-fluid">
        <div class="row clearfix">
          <div class="col-lg-12">
            <div class="card">
              <!--              <div class="row">
                              <div class="col-lg-12">
                                <select v-model="pageSize">
                                  <option value="10">10</option>
                                  <option value="50">50</option>
                                  <option value="100">100</option>
                                </select>
                              </div>
                            </div>-->
              <div class="card mt-2">
                <div class="card-header bg-info">
                  <div class="row">
                    <div class="col">
                      .:: فیلتر گذاری ::.
                    </div>

                  </div>


                </div>
                <div class="card-body bg-white">

                  <form @submit.prevent="getScores(1,true)">
                    <div class="row m-0 mb-2">
                      <!--                                    <div class="col border p-0 pt-1 pb-2 m-2">
                                                            <div class="col-md-12">
                                                              <label class="form-label text-black">تامین کننده</label>
                                                              <select
                                                                  class="form-control show-tick ms select2"
                                                                  data-placeholder="انتخاب کنید"
                                                                  style="height:auto;" v-model="filterOrder.SupplierId">

                                                                <option value="678b97bab3f8164454040d18">
                                                                  تولیدی صنعتی بهران موتور گلپایگان
                                                                </option>
                                                              </select>
                                                            </div>
                                                          </div>-->
                      <div class="col-md-4 border p-0 pt-1 pb-2 m-2">
                        <div class="col-md-12">
                          <label class="form-label text-black">شماره همراه یا تفصیل مشتری</label>
                          <input type="text" class="form-control text-left" v-model="filterScores.Mobile">
                        </div>
                      </div>
                    </div>
                    <!--                                  <div class="row m-0 mb-2">
                                                        <div class="col border p-0 pt-1 pb-2 m-2">
                                                          <div class="col-md-12">
                                                            <label class="form-label text-black">تاریخ تحویل</label>
                                                            <div class="row">
                                                              <div class="col">
                                                                <date-picker
                                                                    type="date"
                                                                    :autoSubmit="true"
                                                                    format="YYYY-MM-DD"
                                                                    display-format="jYYYY/jMM/jDD"
                                                                    v-model="filterOrder.FromDate" placeholder="از تاریخ"
                                                                    inputClass="form-control text-left"
                                                                ></date-picker>
                                                              </div>
                                                              <div class="col">
                                                                <date-picker
                                                                    type="date"
                                                                    :autoSubmit="true"
                                                                    format="YYYY-MM-DD"
                                                                    display-format="jYYYY/jMM/jDD"
                                                                    v-model="filterOrder.ToDate" placeholder="تا تاریخ"
                                                                    inputClass="form-control text-left"
                                                                ></date-picker>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                        <div class="col border p-0 pt-1 pb-2 m-2">
                                                          <div class="col-md-12">
                                                            <label class="form-label text-black">وضعیت محموله</label>
                                                            <select
                                                                class="form-control show-tick ms select2"
                                                                data-placeholder="انتخاب کنید"
                                                                style="height:auto;" v-model="filterOrder.OrderStatus">

                                                              <option value="0">
                                                                تایید نشده
                                                              </option>
                                                              <option value="1">
                                                                تایید شده
                                                              </option>
                                                            </select>
                                                          </div>
                                                        </div>
                                                      </div>-->


                    <div class="row m-0 mb-2">
                      <div class="col text-right" style="direction: rtl;">
                        <button class="btn btn-primary" type="submit">
                          فیلتر کن
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>

              <div class="body">

                <div class="table-responsive">
                  <table
                      class="table table-bordered table-striped table-hover">
                    <thead class="bg-info">
                    <tr>
                      <th class="text-center">ردیف</th>
                      <th class="text-center">نام مشتری</th>
                      <th class="text-center">تفصیل مشتری</th>
                      <th class="text-center">جمع امتیاز(ریال)</th>
                      <!--                      <th class="text-center">وضعیت رسیدگی</th>
                                            <th class="text-center">تاریخ ثبت</th>
                                            <th class="text-center">تعداد اقلام</th>-->

                      <!--<th class="text-center">محل تحویل</th>
                      <th class="text-center">زمان تایید</th>
                      <th class="text-center">گواهی مرغوبیت</th>-->
                      <th class="text-center">عملیات</th>
                    </tr>
                    </thead>
                    <!--                    <tfoot class="bg-info">
                                        </tfoot>-->
                    <tbody class="text-center">
                    <!--                    <tr v-if="customersClub.length===0">
                                          <td class="p-3 align-middle" colspan="20">رکوردی برای نمایش وجود ندارد</td>
                                        </tr>-->
                    <tr v-for="(item,index) in customersClub" :key="index">
                      <td class="p-1 align-middle">{{ index + 1 }}</td>
                      <td class="p-1 align-middle">{{ item.FullName }}</td>
                      <td class="p-1 align-middle">{{ item.Code }}</td>
                      <td class="p-1 align-middle">
                        {{ item.TotalScore }}
                      </td>


                      <!--                  <td class="p-1 align-middle">1</td>
                                            <td class="p-1 align-middle">1</td>



                                            <td class="p-1 align-middle">
                                              <span class="text-success">
                                                <a target="_blank"
                                                   :href="`http://localhost:3269/API/V1/Orders/GenerateQualityCertificate?OrderId=${item.InvoiceId}`">
                                                  <i class="zmdi zmdi-flag" style="color: #1CBFD0;font-size: 25px;"></i>
                                                </a>
                                              </span>
                                            </td>-->
                      <td class="p-1 align-middle">
                        <a title="کسر امتیاز" style="cursor: pointer;" @click="openSaveScoreModal(item.PartyRef)">
                          <i class="zmdi zmdi-minus-circle-outline" style="color: #1CBFD0;font-size: 25px;"></i>
                        </a>
                        &nbsp;
                        <a title="مشاهده امتیازها" style="cursor: pointer;" @click="openScoreListModal(item.PartyRef)">
                          <i class="zmdi zmdi-menu" style="color: #1CBFD0;font-size: 25px;"></i>
                        </a>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <paginate
                :page-count="pageCount"
                :click-handler="getScores"
                :prev-text="'prev'"
                :next-text="'next'" :page-range="5"
                :container-class="'custom-pagination'">
            </paginate>
          </div>
        </div>


      </div>
    </div>

    <div class="modal fade" id="div_AlertModal" tabindex="-1" role="dialog" style="z-index: 10000 !important;">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header bg-info justify-content-between pt-1 pb-1">
            <span class="title text-white">پیغام سیستم</span>
            <span data-dismiss="modal" class="btn btn-link text-white pt-1">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div ref="div_AlertModalMessage"></div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>


    <div class="modal fade" id="div_CustomerInfoModal" tabindex="-1" role="dialog" style="z-index: 10000 !important;">
      <div class="modal-dialog modal-dialog-centered modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header bg-info justify-content-between pt-1 pb-1">
            <span class="title text-white">پیغام سیستم</span>
            <span data-dismiss="modal" class="btn btn-link text-white pt-1">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div ref="div_CustomerInfo"></div>
            </simplebar>
          </div>
        </div>
      </div>
    </div>

    <!--    <div class="modal fade" id="div_ReportTestModal" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content">
              <div class="modal-header justify-content-between pt-3">
                <span class="title">لیست اقلام</span>
                <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
              </div>
              <div class="modal-body">
                <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
                  <div>
                    <form>
                      <div class="row m-0">
                        <div class="col-md-12">
                          <div class="table-responsive">
                            <table
                                class="table table-bordered table-striped table-hover">
                              <thead>
                              <tr>
                                <th class="text-center">ردیف</th>
                                <th class="text-center">عنوان</th>
                                <th class="text-center">تعداد</th>
                              </tr>
                              </thead>

                              <tbody class="text-center">
                              <tr v-for="(item,index) in pendingOrderData.PendingOrderList" :key="index">
                                <td class="p-1 align-middle">{{ index + 1 }}</td>
                                <td class="p-1 align-middle">{{ item.Title }}</td>
                                <td class="p-1 align-middle">{{ item.Quantity }}</td>

                              </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </simplebar>

              </div>
              &lt;!&ndash;          <div class="modal-footer">
                          <div class="row">
                            <div class="col text-right" style="direction: rtl;">
                              <button class="btn btn-primary" @click="shipmentVerification">
                                تایید محموله
                              </button>
                            </div>
                          </div>
                        </div>&ndash;&gt;
            </div>
          </div>
        </div>-->


    <div class="modal fade" id="div_SaveScoreModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title">کسر امتیاز</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:450px;">
              <div>
                <form @submit.prevent="saveScore">
                  <div class="row m-0 mb-2">
                    <div class="col border p-2 pt-1 pb-2 m-2">
                      <label class="form-label text-black">امتیاز مورد نظر</label>
                      <input type="text" class="form-control" v-model="score">
                    </div>
                  </div>

                  <div class="row">
                    <div class="col text-right" style="direction: rtl;text-align: right;">
                      <button class="btn btn-success" type="submit">
                        ثبت
                      </button>
                      <button class="btn btn-danger" data-dismiss="modal">
                        انصراف
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </simplebar>

          </div>

        </div>
      </div>
    </div>


    <div class="modal fade" id="div_BlockListModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title">لیست سفید</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">

            <div class="border-black border mb-2">
              <form @submit.prevent="saveBlockParty">
                <div class="row m-0 mb-2">
                  <div class="col border p-2 pt-1 pb-2 m-2">
                    <label class="form-label text-black">تفصیل شخص</label>
                    <input type="number" class="form-control text-left" v-model="partyId">
                  </div>
                </div>

                <div class="row m-0">
                  <div class="col text-right" style="direction: rtl;text-align: right;">
                    <button class="btn btn-success" type="submit">
                      ثبت
                    </button>
                    <!--<button class="btn btn-danger" data-dismiss="modal">
                      انصراف
                    </button>-->
                  </div>
                </div>
              </form>
            </div>
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:450px;">
              <div class="row">
                <div class="col">
                  <div class="table-responsive">
                    <table
                        class="table table-bordered table-striped table-hover">
                      <thead class="bg-info">
                      <tr>
                        <th class="text-center">ردیف</th>
                        <th class="text-center">نام مشتری</th>
                        <th class="text-center">زمان ثبت</th>
                        <th class="text-center">عملیات</th>
                      </tr>
                      </thead>
                      <tbody class="text-center">
                      <tr v-for="(item,index) in customerBlockList" :key="index">
                        <td class="p-1 align-middle">{{ index + 1 }}</td>
                        <td class="p-1 align-middle">{{ item.FullName }}</td>
                        <td class="p-1 align-middle">{{ $formatDateTime(item.CreationDate) | moment("jYYYY/jM/jDD-HH:mm") }}</td>
                        <td class="p-1 align-middle">
                          <a style="cursor: pointer;" @click="clearPartyBlock(item.Id)">
                            <i class="zmdi zmdi-delete" style="color: #1CBFD0;font-size: 25px;"></i>
                          </a>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </simplebar>

          </div>

        </div>
      </div>
    </div>


    <div class="modal fade" id="div_AddManualScoreModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title">امتیاز دستی</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">

            <div class="border-black border mb-2">
              <form @submit.prevent="saveManualScore">
                <div class="row m-0">
                  <div class="col border p-2 pt-1 pb-2 m-2">
                    <label class="form-label text-black">کد تفصیل شخص</label>
                    <input type="number" class="form-control text-left" v-model="manualPartyId">
                  </div>

                </div>
                <div class="row m-0">
                  <div class="col border p-2 pt-1 pb-2 m-2">
                    <label class="form-label text-black">مبلغ امتیاز(ریال)</label>
                    <input type="number" class="form-control text-left" v-model="manualAmount">
                  </div>
                </div>

                <div class="row m-0">
                  <div class="col text-right" style="direction: rtl;text-align: right;">
                    <button class="btn btn-success" type="submit">
                      ثبت
                    </button>
                    <!--<button class="btn btn-danger" data-dismiss="modal">
                      انصراف
                    </button>-->
                  </div>
                </div>
              </form>
            </div>


          </div>

        </div>
      </div>
    </div>


    <div class="modal fade" id="div_ScoreListModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title">لیست امیتازها</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:450px;">
              <div class="row">
                <div class="col">
                  <div class="table-responsive">
                    <table
                        class="table table-bordered table-striped table-hover">
                      <thead class="bg-info">
                      <tr>
                        <th class="text-center">ردیف</th>
                        <th class="text-center">مبلغ امتیاز(ریال)</th>
                        <th class="text-center">نوع محاسبه</th>
                        <th class="text-center">نوع امتیاز</th>
                        <th class="text-center">زمان ثبت</th>
                        <th class="text-center">وضعیت ارسال پیامک</th>
                        <th class="text-center">شناسه فاکتور فروش</th>
                        <th class="text-center">مبلغ خالص فاکتور</th>
                        <!--                        <th class="text-center">عملیات</th>-->
                      </tr>
                      </thead>
                      <tbody class="text-center">
                      <tr v-for="(item,index) in customerScoreList" :key="index">
                        <td class="p-1 align-middle">{{ index + 1 }}</td>
                        <td class="p-1 align-middle">{{ item.ScoreAmount }}</td>
                        <td class="p-1 align-middle">{{ item.ScoreType }}</td>
                        <td class="p-1 align-middle">{{ item.TransactionType }}</td>
                        <td class="p-1 align-middle">{{ $formatDateTime(item.CreationDate) | moment("jYYYY/jM/jDD-HH:mm") }}</td>
                        <td class="p-1 align-middle">{{ item.SendSms }}</td>
                        <td class="p-1 align-middle">{{ item.InvoiceRef }}</td>
                        <td class="p-1 align-middle">{{ item.NetPrice }}</td>
                        <!--                        <td class="p-1 align-middle">
                                                  <a style="cursor: pointer;" @click="clearPartyBlock(item.Id)">
                                                    <i class="zmdi zmdi-delete" style="color: #1CBFD0;font-size: 25px;"></i>
                                                  </a>
                                                </td>-->
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </simplebar>

          </div>

        </div>
      </div>
    </div>

    <!--    <div class="modal fade" id="div_NewPendingOrderModal" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-md" role="document">
            <div class="modal-content">
              <div class="modal-header justify-content-between pt-3">
                <span class="title">محموله جدید</span>
                <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
              </div>
              <div class="modal-body">
                <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
                  <div>
                    <form>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">شرح قطعه</label>
                          <input type="text" class="form-control text-right" v-model="newShipment.PartDescription">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">شماره فنی</label>
                          <input type="text" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.PartNumber">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">کد کالا</label>
                          <input type="text" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.ItemCode">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">تعداد پالت</label>
                          <input type="number" class="form-control text-left" style="direction: ltr;" min="1"
                                 v-model="newShipment.PalletQuantity">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">نوع پالت</label>
                          <select class="form-control" v-model="newShipment.PalletType">
                            <option value="MS174">پالت نوع 1</option>
                            <option value="MS175">پالت نوع 2</option>
                            <option value="MS176">پالت نوع 3</option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">زمان آزاد سازی</label>
                          <date-picker
                              type="datetime"
                              :autoSubmit="true"
                              format="YYYY-MM-DD HH:mm"
                              display-format="jYYYY/jMM/jDD-HH:mm" inputClass="form-control text-left"
                              v-model="newShipment.ReleaseTime"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">زمان اعتبار</label>
                          <date-picker
                              type="datetime"
                              :autoSubmit="true"
                              format="YYYY-MM-DD HH:mm"
                              display-format="jYYYY/jMM/jDD-HH:mm" inputClass="form-control text-left"
                              v-model="newShipment.ValidTime"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">شماره محموله</label>
                          <input type="text" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.ShipmentNumber">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">مشتری</label>
                          <select class="form-control" v-model="newShipment.CustomerId">
                            <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                            <option v-for="(item,index) in customers" :key="index" :value="item._id">{{
                                item.CustomerTitle
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">انبار</label>
                          <select class="form-control" v-model="newShipment.WarehouseId">
                            <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                            <option v-for="(item,index) in warehouseList" :key="index" :value="item._id">{{
                                item.WarehouseTitle
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">خودرو</label>
                          <select class="form-control" v-model="newShipment.VehicleId">
                            <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                            <option v-for="(item,index) in vehicleList" :key="index" :value="item._id">{{
                                item.VehicleTitle
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">نوع ارسال</label>
                          <select class="form-control" v-model="newShipment.ShippingType">
                            <option value="کانبان مشتری">کانبان مشتری</option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">تعداد در پالت</label>
                          <input type="number" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.QuantityPerPallet">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">تعداد</label>
                          <input type="number" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.Quantity">
                        </div>
                      </div>
                    </form>
                  </div>
                </simplebar>

              </div>
              <div class="modal-footer">
                <div class="row">
                  <div class="col text-right" style="direction: rtl;text-align: right;">
                    <button class="btn btn-success" @click="addNewPendingOrder">
                      ثبت محموله
                    </button>
                    <button class="btn btn-danger" data-dismiss="modal">
                      انصراف
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->
    <!--    <div class="modal fade" id="div_EditShipmentModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header justify-content-between pt-3">
            <span class="title">ویرایش محموله</span>
            <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
          </div>
          <div class="modal-body">
            <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
              <div class="row bg-light p-2 mb-3">
                <div class="col">
                  <div class="row pb-2">
                    <div class="col">
                      <span>
                        نام سازنده:
                      </span>
                      {{ shipment?.SupplierDetail?.SupplierTitle }}
                    </div>
                    <div class="col">
                      <span>
                        کد سازنده:
                      </span>
                      {{ shipment?.SupplierDetail?.SupplierCode }}
                    </div>
                    <div class="col">
                      <span>
                        شماره محموله:
                      </span>
                      {{ shipment?.ShipmentNumber }}

                    </div>
                  </div>
                  <div class="row pb-2">
                    <div class="col">
                      <span>
                        مشتری:
                      </span>
                      {{ shipment?.CustomerDetails?.CustomerTitle }}
                    </div>
                    <div class="col">
                      <span>
                        محل تحویل:
                      </span>
                      {{ shipment?.WarehouseDetail?.WarehouseTitle }}
                    </div>
                    <div class="col">

                    </div>
                  </div>
                  <div class="row pb-2">
                    <div class="col">
                      <span>
                        تاریخ ثبت:
                      </span>
                      {{ shipment?.CreatedAt | moment("jYYYY/jM/jD") }}
                    </div>
                    <div class="col">
                      <span>
                        تاریخ تحویل:
                      </span>
                      {{ shipment?.EstimatedArrivalTime | moment("jYYYY/jM/jD") }}
                    </div>
                    <div class="col">
                      <span>
                        تاریخ بازرسی:
                      </span>
                      {{ shipment?.ConfirmedAt | moment("jYYYY/jM/jD") }}
                    </div>
                  </div>
                  <div class="row pb-2">
                    <div class="col">
                      <form class="form-inline">
                        <div class="form-group mb-2">
                          <label for="staticEmail2">شماره حواله سازنده: </label>
                          &nbsp;
                          <input type="text" class="form-control" v-model="shipment.ShipmentNumber">
                        </div>
                        <div class="form-group mx-sm-3 mb-2">
                          <label for="inputPassword2">توضیحات: </label>
                          &nbsp;
                          <input type="text" class="form-control" id="inputPassword2" v-model="shipment.Desc">
                        </div>
                      </form>
                    </div>


                  </div>
                </div>
              </div>
              <div>
                <form>
                  <div class="row m-0">
                    <div class="col-md-12">
                      <div class="table-responsive">
                        <table
                            class="table table-bordered table-hover">
                          <thead>
                          <tr>
                            <th class="text-center">ردیف</th>
                            <th class="text-center">شرح قطعه</th>
                            <th class="text-center">شماره فنی</th>
                            <th class="text-center">کد کالا</th>
                            <th class="text-center">تعداد ارسالی</th>
                            <th class="text-center">گواهی مرغوبیت</th>
                            <th class="text-center">ابطال</th>
                            <th class="text-center">وضعیت</th>
                            <th class="text-center">آخرین بروزرسانی</th>
                            <th class="text-center">TestReport</th>
                            <th class="text-center">تعداد نهایی</th>
                          </tr>
                          </thead>

                          <tbody class="text-center">
                          <tr v-for="(item,index) in shipment?.PendingOrder" :key="index"
                              :class="{'disabled-row': !completeAbandonButtonVisible || !orderItemsStatus(item.Status)}">
                            <td class="p-1 align-middle">{{ index + 1 }}</td>
                            <td class="p-1 align-middle">{{ item.PartDescription }}</td>
                            <td class="p-1 align-middle">{{ item.PartNumber }}</td>
                            <td class="p-1 align-middle">{{ item.ItemCode }}</td>
                            <td class="p-1 align-middle">{{ item.OrderQuantity }}</td>
                            <td class="p-1 align-middle">{{ item.QualityCertificate }}</td>
                            <td class="p-1 align-middle">
                              <input type="checkbox" style="height: 20px;width: 20px;" v-model="item.selected"
                                     @change="addToAbandonList(item, $event)">
                            </td>
                            <td class="p-1 align-middle">
                              <span class="text-success">
                                <i class="zmdi zmdi-flag"></i>
                              </span>
                            </td>

                            <td class="p-1 align-middle">
                              <span v-if="item.UpdatedAt!=null">
                                {{ item.UpdatedAt | moment("jYYYY/jM/jD-HH:mm") }}
                              </span>
                            </td>
                            <td class="p-1 align-middle">
                              <span v-if="item.TestReport===null">
                                ندارد
                              </span>
                              <a href="#" target="_blank" v-else>
                                نمایش
                              </a>

                            </td>
                            <td class="p-1 align-middle">
                              <div class="d-flex align-items-center">
                                <input type="number" class="form-control" min="1" v-model="item.OrderQuantity"
                                       style="width:100px;text-align: left;direction: ltr;">
                                &nbsp;
                                <button type="button" class="btn btn-success"
                                        @click="updateOrderQuantity(item._id,item.OrderQuantity)"
                                        style="display: inline;">
                                  ثبت
                                </button>
                              </div>

                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </simplebar>
          </div>
          <div class="modal-footer">
            <div class="row">
              <div class="col text-right" style="direction: rtl;">
                <button type="button" class="btn btn-danger" @click="cancelOrderItems" v-if="cancelOrderItemsButtonVisible">
                  ابطال انتخابی ها
                </button>
                <button type="button" class="btn btn-danger" @click="completeAbandonment"
                        v-if="completeAbandonButtonVisible">
                  ابطال کل محموله
                </button>
                <button class="btn btn-primary" data-dismiss="modal">
                  بستن
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->
    <!--    <div class="modal fade" id="div_NewPendingOrderModal" tabindex="-1" role="dialog">
          <div class="modal-dialog modal-dialog-centered modal-md" role="document">
            <div class="modal-content">
              <div class="modal-header justify-content-between pt-3">
                <span class="title">محموله جدید</span>
                <span data-dismiss="modal" class="btn btn-link text-muted pt-0">بستن</span>
              </div>
              <div class="modal-body">
                <simplebar class="col-xl-12" data-simplebar-auto-hide="false" style="height:400px;">
                  <div>
                    <form>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">شرح قطعه</label>
                          <input type="text" class="form-control text-right" v-model="newShipment.PartDescription">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">شماره فنی</label>
                          <input type="text" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.PartNumber">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">کد کالا</label>
                          <input type="text" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.ItemCode">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">تعداد پالت</label>
                          <input type="number" class="form-control text-left" style="direction: ltr;" min="1"
                                 v-model="newShipment.PalletQuantity">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">نوع پالت</label>
                          <select class="form-control" v-model="newShipment.PalletType">
                            <option value="MS174">پالت نوع 1</option>
                            <option value="MS175">پالت نوع 2</option>
                            <option value="MS176">پالت نوع 3</option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">زمان آزاد سازی</label>
                          <date-picker
                              type="datetime"
                              :autoSubmit="true"
                              format="YYYY-MM-DD HH:mm"
                              display-format="jYYYY/jMM/jDD-HH:mm" inputClass="form-control text-left"
                              v-model="newShipment.ReleaseTime"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">زمان اعتبار</label>
                          <date-picker
                              type="datetime"
                              :autoSubmit="true"
                              format="YYYY-MM-DD HH:mm"
                              display-format="jYYYY/jMM/jDD-HH:mm" inputClass="form-control text-left"
                              v-model="newShipment.ValidTime"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">شماره محموله</label>
                          <input type="text" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.ShipmentNumber">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">مشتری</label>
                          <select class="form-control" v-model="newShipment.CustomerId">
                            <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                            <option v-for="(item,index) in customers" :key="index" :value="item._id">{{
                                item.CustomerTitle
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">انبار</label>
                          <select class="form-control" v-model="newShipment.WarehouseId">
                            <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                            <option v-for="(item,index) in warehouseList" :key="index" :value="item._id">{{
                                item.WarehouseTitle
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">خودرو</label>
                          <select class="form-control" v-model="newShipment.VehicleId">
                            <option selected disabled>&#45;&#45;انتخاب کنید&#45;&#45;</option>
                            <option v-for="(item,index) in vehicleList" :key="index" :value="item._id">{{
                                item.VehicleTitle
                              }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">نوع ارسال</label>
                          <select class="form-control" v-model="newShipment.ShippingType">
                            <option value="کانبان مشتری">کانبان مشتری</option>
                          </select>
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">تعداد در پالت</label>
                          <input type="number" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.QuantityPerPallet">
                        </div>
                      </div>
                      <div class="row m-0 mb-2">
                        <div class="col border p-2 pt-1 pb-2 m-2">
                          <label class="form-label text-black">تعداد</label>
                          <input type="number" class="form-control text-left" style="direction: ltr;"
                                 v-model="newShipment.Quantity">
                        </div>
                      </div>
                    </form>
                  </div>
                </simplebar>

              </div>
              <div class="modal-footer">
                <div class="row">
                  <div class="col text-right" style="direction: rtl;text-align: right;">
                    <button class="btn btn-success" @click="addNewPendingOrder">
                      ثبت محموله
                    </button>
                    <button class="btn btn-danger" data-dismiss="modal">
                      انصراف
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->

  </section>
</template>
<script>
/* eslint-disable */
import axios from "axios";
import simplebar from "simplebar-vue";
import "simplebar/dist/simplebar.min.css";
// import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Paginate from "vuejs-paginate";
// import Vue from 'vue';
import VuePersianDatetimePicker from "vue-persian-datetime-picker";

// import moment from "vue-moment-jalaali";
// import VueUploadMultipleImage from 'vue-upload-multiple-image';
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";


export default {
  data() {
    return {
      filterScores: {
        Mobile: ""
      },
      customersClub: [],
      pageCount: 0,
      pageIndex: 0,
      score: null,
      partyRef: null,
      filterStatus: false,
      partyId: null,
      customerBlockList: [],
      manualPartyId: null,
      manualAmount: null,
      customerScoreList: [],
      loadingShow: false
    };
  },
  methods:
      {
        openScoreListModal(partyId) {
          let self = this;
          let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
          self.loadingShow = true;
          axios.post("https://araksolar.ir/webhook/GetCustomerClubScores", {
            Request: "GetScoresByPartyId",
            PartyId: partyId
          }, {
            headers: {
              'Content-Type': 'application/json',
              // Authorization: userInfo.Token
            }
          })
              .then(function (res) {
                let {Data, Message, Status} = res.data[0];
                $("#div_ScoreListModal").modal({backdrop: "static"});
                console.log(res.data);
                self.customerScoreList = Data;
                self.loadingShow = false;
              })
              .catch(function (error) {
                console.log(error);
                self.loadingShow = false;
              })
              .finally(function (res) {
                self.loadingShow = false;
              });

        },
        saveManualScore() {
          let self = this;
          let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
          self.loadingShow = true;
          axios.post("https://araksolar.ir/webhook/GetCustomerClubScores", {
            PartyId: self.manualPartyId,
            Amount: self.manualAmount,
            Request: "SaveManualScore"
          }, {
            headers: {
              'Content-Type': 'application/json',
              // Authorization: userInfo.Token
            }
          })
              .then(function (res) {
                let {Data, Message, Status} = res.data[0];
                if (Status === 1) {
                  self.manualPartyId = null;
                  self.manualAmount = null;
                  self.$toast.open({
                    position: "bottom-right",
                    message: Message,
                    type: "success",
                    duration: 5000
                  });
                  self.getScores(self.pageIndex);
                } else {
                  self.$toast.open({
                    position: "bottom-right",
                    message: Message,
                    type: "error",
                    duration: 5000
                  });
                }

                self.loadingShow = false;
              })
              .catch(function (error) {
                console.log(error);
                // self.loadingShow = false;
              })
              .finally(function (res) {
                self.loadingShow = false;
              });
        },
        openAddManualScoreModal() {
          let self = this;
          //self.partyId = null;

          $("#div_AddManualScoreModal").modal({backdrop: "static"});
        },
        clearPartyBlock(id) {
          let self = this;
          //self.pageIndex = pageIndex;
          //self.filterStatus = filterStatus;
          let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
          self.loadingShow = true;
          axios.post("https://araksolar.ir/webhook/GetCustomerClubScores", {
            Request: "ClearPartyBlock",
            Id: id
          }, {
            headers: {
              'Content-Type': 'application/json',
              // Authorization: userInfo.Token
            }
          })
              .then(function (res) {
                if (res.data[0]!==undefined){
                  let {Data, Message, Status} = res.data[0];
                  self.$toast.open({
                    position: "bottom-right",
                    message: Message,
                    type: "success",
                    duration: 5000
                  });
                  console.log(res.data);
                }

                self.getCustomerBlockList();
                //self.customerBlockList = Data;
                //self.pageCount = res.data[0].pageCount;
                //self.$refs.div_CustomerInfo.innerHTML =`<p><strong>آدرس: </strong>${res.data[0].Address}</p>` ;
                //self.$refs.div_CustomerInfo.innerHTML +=`<p><strong>تلفن: </strong>${res.data[0].Phone}</p>`;
                //$("#div_CustomerInfoModal").modal({backdrop: "static"});
                self.loadingShow = false;

                //$("#div_CustomerInfo").modal("show");
                /*if (Status === 1) {
                  self.loadingShow = false;
                  self.customers = Data.Customers;
                } else {
                  self.loadingShow = false;
                  self.$refs.div_AlertModalMessage.innerHTML = Message;
                  $("#div_AlertModal").modal({backdrop: "static"});
                }*/
              })
              .catch(function (error) {
                console.log(error);
                self.loadingShow = false;
              })
              .finally(function (res) {
                self.loadingShow = false;
              });
        },
        getCustomerBlockList() {
          let self = this;
          //self.pageIndex = pageIndex;
          //self.filterStatus = filterStatus;
          let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
          self.loadingShow = true;
          axios.post("https://araksolar.ir/webhook/GetCustomerClubScores", {
            Request: "GetBlockList"
          }, {
            headers: {
              'Content-Type': 'application/json',
              // Authorization: userInfo.Token
            }
          })
              .then(function (res) {
                if (res.data[0]!==undefined){
                  let {Data, Message, Status} = res.data[0];
                  console.log(res.data);
                  self.customerBlockList = Data;
                  self.loadingShow = false;
                }

                //self.pageCount = res.data[0].pageCount;
                //self.$refs.div_CustomerInfo.innerHTML =`<p><strong>آدرس: </strong>${res.data[0].Address}</p>` ;
                //self.$refs.div_CustomerInfo.innerHTML +=`<p><strong>تلفن: </strong>${res.data[0].Phone}</p>`;
                //$("#div_CustomerInfoModal").modal({backdrop: "static"});

                //$("#div_CustomerInfo").modal("show");
                /*if (Status === 1) {
                  self.loadingShow = false;
                  self.customers = Data.Customers;
                } else {
                  self.loadingShow = false;
                  self.$refs.div_AlertModalMessage.innerHTML = Message;
                  $("#div_AlertModal").modal({backdrop: "static"});
                }*/
              })
              .catch(function (error) {
                console.log(error);
                self.loadingShow = false;
              })
              .finally(function (res) {
                self.loadingShow = false;
              });
        },
        openBlockListModal() {
          let self = this;
          self.partyId = null;
          self.getCustomerBlockList();
          $("#div_BlockListModal").modal({backdrop: "static"});
        },
        saveBlockParty() {
          let self = this;
          let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
          self.loadingShow = true;
          axios.post("https://araksolar.ir/webhook/GetCustomerClubScores", {
            PartyId: self.partyId,
            Request: "SaveBlockParty"
          }, {
            headers: {
              'Content-Type': 'application/json',
              // Authorization: userInfo.Token
            }
          })
              .then(function (res) {
                let {Data, Message, Status} = res.data[0];
                //self.getScores(self.pageIndex);
                console.log(res.data);
                self.getCustomerBlockList();
                $("#div_BlockListModal").modal("hide");
                self.$toast.open({
                  position: "bottom-right",
                  message: Message,
                  type: "success",
                  duration: 5000
                });

              })
              .catch(function (error) {
                console.log(error);
                // self.loadingShow = false;
              })
              .finally(function (res) {
                self.loadingShow = false;
              });
        },
        openSaveScoreModal(partyRef) {
          let self = this;
          self.partyRef = partyRef;
          $("#div_SaveScoreModal").modal({backdrop: "static"});
        },
        saveScore() {
          let self = this;
          let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
          self.loadingShow = true;
          axios.post("https://araksolar.ir/webhook/GetCustomerClubScores", {
            Score: self.score,
            PartyRef: self.partyRef,
            Request: "SaveScore"
          }, {
            headers: {
              'Content-Type': 'application/json',
              // Authorization: userInfo.Token
            }
          })
              .then(function (res) {
                let {Data, Message, Status} = res.data[0];
                self.getScores(self.pageIndex);
                console.log(res.data);
                $("#div_SaveScoreModal").modal("hide");
                self.$toast.open({
                  position: "bottom-right",
                  message: Message,
                  type: "success",
                  duration: 5000
                });

              })
              .catch(function (error) {
                console.log(error);
                // self.loadingShow = false;
              })
              .finally(function (res) {
                self.loadingShow = false;
              });
        },
        getScores(pageIndex = 1, filterStatus = false) {
          let self = this;
          self.pageIndex = pageIndex;
          self.filterStatus = filterStatus;
          let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
          self.loadingShow = true;
          axios.post("https://araksolar.ir/webhook/GetCustomerClubScores", {
            Page: pageIndex,
            Request: "GetScores",
            FilterStatus: self.filterStatus,
            FilterParams: self.filterScores
          }, {
            headers: {
              'Content-Type': 'application/json',
              // Authorization: userInfo.Token
            }
          })
              .then(function (res) {
                // let {Data, Message, Status} = res.data;
                console.log(res.data);
                self.customersClub = res.data[0].scores;
                self.pageCount = res.data[0].pageCount;
                //self.$refs.div_CustomerInfo.innerHTML =`<p><strong>آدرس: </strong>${res.data[0].Address}</p>` ;
                //self.$refs.div_CustomerInfo.innerHTML +=`<p><strong>تلفن: </strong>${res.data[0].Phone}</p>`;
                //$("#div_CustomerInfoModal").modal({backdrop: "static"});
                self.loadingShow = false;
                //$("#div_CustomerInfo").modal("show");
                /*if (Status === 1) {
                  self.loadingShow = false;
                  self.customers = Data.Customers;
                } else {
                  self.loadingShow = false;
                  self.$refs.div_AlertModalMessage.innerHTML = Message;
                  $("#div_AlertModal").modal({backdrop: "static"});
                }*/
              })
              .catch(function (error) {
                console.log(error);
                self.loadingShow = false;
              })
              .finally(function (res) {
                self.loadingShow = false;
              });
        },
        /*handlingOrder() {
          let self = this;
          // let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
          self.loadingShow = true;
          axios.post("http://localhost:5678/webhook/HandlingOrder", {
            ItemList: self.pendingOrderData.PendingOrderList
          }, {
            headers: {
              'Content-Type': 'application/json',
              // Authorization: userInfo.Token
            }
          })
              .then(function (res) {
                let {Data, Message, Status} = res.data[0];
                console.log(Data);

                if (Status === 1) {
                  self.loadingShow = false;
                  // $("#div_ReportTestModal").modal("hide");
                  self.getOrders();
                  self.$toast.open({
                    position: "bottom-right",
                    message: Message,
                    type: "success",
                    duration: 5000
                  });
                } else {
                  self.loadingShow = false;
                  // self.$refs.div_AlertModalMessage.innerHTML = Message;
                  // $("#div_AlertModal").modal({backdrop: "static"});
                }
              })
              .catch(function (error) {
                console.log(error);
                self.loadingShow = false;
              })
              .finally(function (res) {
                console.log("TEST")
                self.loadingShow = false;
              });
        },*/
        /* openCustomerInfoModal(partyRef) {
           let self = this;
           let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
           self.loadingShow = true;
           axios.get("http://localhost:5678/webhook/6a6bb84f-4f02-42ad-b876-aef017a05c0e", {
             headers: {
               'Content-Type': 'application/json',
               Authorization: userInfo.Token
             },
             params: {
               PartyRef: partyRef
             }
           })
               .then(function (res) {
                 // let {Data, Message, Status} = res.data;
                 console.log(res.data);
                 self.$refs.div_CustomerInfo.innerHTML = `<p><strong>آدرس: </strong>${res.data[0].Address}</p>`;
                 self.$refs.div_CustomerInfo.innerHTML += `<p><strong>تلفن: </strong>${res.data[0].Phone}</p>`;
                 $("#div_CustomerInfoModal").modal({backdrop: "static"});
                 self.loadingShow = false;
                 //$("#div_CustomerInfo").modal("show");
                 /!*if (Status === 1) {
                   self.loadingShow = false;
                   self.customers = Data.Customers;
                 } else {
                   self.loadingShow = false;
                   self.$refs.div_AlertModalMessage.innerHTML = Message;
                   $("#div_AlertModal").modal({backdrop: "static"});
                 }*!/
               })
               .catch(function (error) {
                 console.log(error);
                 self.loadingShow = false;
               })
               .finally(function (res) {
                 self.loadingShow = false;
               });
         },*/
        /*openHandlingOrderModal(invoiceId) {
          let self = this;
          let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
          self.loadingShow = true;
          axios.get("http://localhost:5678/webhook/4e25964c-9f6e-469a-aa33-5da3be7614a6", {
            headers: {
              'Content-Type': 'application/json',
              Authorization: userInfo.Token
            },
            params: {
              InvoiceId: invoiceId
            }
          })
              .then(function (res) {
                // let {Data, Message, Status} = res.data;
                console.log(res.data);
                self.pendingOrderData.PendingOrderList = res.data.invoiceItems;
                self.permissions = res.data.permission;
                self.loadingShow = false;
                $("#div_HandlingModal").modal("show");
                /!*if (Status === 1) {
                  self.loadingShow = false;
                  self.customers = Data.Customers;
                } else {
                  self.loadingShow = false;
                  self.$refs.div_AlertModalMessage.innerHTML = Message;
                  $("#div_AlertModal").modal({backdrop: "static"});
                }*!/
              })
              .catch(function (error) {
                console.log(error);
                self.loadingShow = false;
              })
              .finally(function (res) {
                self.loadingShow = false;
              });
        },*/
        /* getItemOrders(invoiceId) {
           let self = this;
           // let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
           self.loadingShow = true;
           axios.get("http://localhost:5678/webhook/4e25964c-9f6e-469a-aa33-5da3be7614a6", {
             headers: {
               'Content-Type': 'application/json',
               // Authorization: userInfo.Token
             },
             params: {
               InvoiceId: invoiceId
             }
           })
               .then(function (res) {
                 // let {Data, Message, Status} = res.data;
                 console.log(res.data);
                 self.pendingOrderData.PendingOrderList = res.data;
                 self.loadingShow = false;
                 $("#div_ReportTestModal").modal("show");
                 /!*if (Status === 1) {
                   self.loadingShow = false;
                   self.customers = Data.Customers;
                 } else {
                   self.loadingShow = false;
                   self.$refs.div_AlertModalMessage.innerHTML = Message;
                   $("#div_AlertModal").modal({backdrop: "static"});
                 }*!/
               })
               .catch(function (error) {
                 console.log(error);
                 self.loadingShow = false;
               })
               .finally(function (res) {
                 self.loadingShow = false;
               });
         },*/
        /*getOrders() {
          let self = this;
          let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
          self.loadingShow = true;
          axios.get("http://localhost:5678/webhook/0508cd98-0b37-4609-8b6f-9f68d4b05332", {
            headers: {
              'Content-Type': 'application/json',
              Authorization: userInfo.Token
            }
          })
              .then(function (res) {
                // let {Data, Message, Status} = res.data;
                console.log(res.data);
                self.ordersData.OrderList = res.data;
                self.loadingShow = false;

                /!*if (Status === 1) {
                  self.loadingShow = false;
                  self.customers = Data.Customers;
                } else {
                  self.loadingShow = false;
                  self.$refs.div_AlertModalMessage.innerHTML = Message;
                  $("#div_AlertModal").modal({backdrop: "static"});
                }*!/
              })
              .catch(function (error) {
                console.log(error);
                self.loadingShow = false;
              })
              .finally(function (res) {
                self.loadingShow = false;
              });
        },*/
        /*selectReportTestFile(itemId) {
          let self = this;
          self.uploadTestFile.ItemId = itemId;
          // console.log(this.$refs)
          this.$refs.fileInput[0].click();
        },*/
        /*shipmentVerification() {
          let self = this;
          let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
          self.loadingShow = true;
          // self.uploadTestFile.ItemId = itemId;
          axios.post("/API/V1/Orders/ShipmentVerification", self.uploadTestFile, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: userInfo.Token
            }
          })
              .then(function (res) {
                let {Data, Message, Status} = res.data;
                console.log(Data);

                if (Status === 1) {
                  self.loadingShow = false;
                  $("#div_ReportTestModal").modal("hide");
                  self.filterOrders();
                  /!*const itemToUpdate = self.pendingOrderData.PendingOrderList.find(item => item._id === Data.ItemId);
                  if (itemToUpdate) {
                    itemToUpdate.TestReport = null;
                    itemToUpdate.UpdatedAt = Data.UpdatedAt
                  }*!/
                  self.$toast.open({
                    position: "bottom-right",
                    message: Message,
                    type: "success",
                    duration: 5000
                  });
                } else {
                  self.loadingShow = false;
                  self.$refs.div_AlertModalMessage.innerHTML = Message;
                  $("#div_AlertModal").modal({backdrop: "static"});
                }
              })
              .catch(function (error) {
                console.log(error);
                self.loadingShow = false;
              })
              .finally(function (res) {
                self.loadingShow = false;
              });
        },*/
        /*uploadTestReport(event) {
          let self = this;
          let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
          self.loadingShow = true;
          const testReportFile = event.target.files[0];
          console.log(testReportFile);
          const formData = new FormData();
          formData.append('TestReportFile', testReportFile);
          formData.append('OrderId', self.uploadTestFile.OrderId);
          formData.append('ItemId', self.uploadTestFile.ItemId);
          axios.post("/API/V1/Orders/UploadTestReport", formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
              Authorization: userInfo.Token
            }
          })
              .then(function (res) {
                let {Data, Message, Status} = res.data;
                console.log(Data);

                if (Status === 1) {
                  self.loadingShow = false;
                  const itemToUpdate = self.pendingOrderData.PendingOrderList.find(item => item._id === Data.ItemId);
                  if (itemToUpdate) {
                    itemToUpdate.TestReport = Data.FileName;
                    itemToUpdate.UpdatedAt = Data.UpdatedAt;
                  }
                  self.$toast.open({
                    position: "bottom-right",
                    message: Message,
                    type: "success",
                    duration: 5000
                  });

                } else {
                  self.loadingShow = false;
                  self.$refs.div_AlertModalMessage.innerHTML = Message;
                  $("#div_AlertModal").modal({backdrop: "static"});
                }
              })
              .catch(function (error) {
                console.log(error);
                self.loadingShow = false;
              })
              .finally(function (res) {
                self.loadingShow = false;
              });
        },*/
        /*openReportTestModal(pendingOrder, orderId) {
          let self = this;
          self.uploadTestFile.OrderId = orderId;
          self.pendingOrderData.PendingOrderList = pendingOrder;
          $("#div_ReportTestModal").modal("show");
        },*/
        /*filterOrders() {
          let self = this;
          let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
          self.loadingShow = true;
          axios.get("/API/V1/Orders/FilterOrders", {
            params: self.filterOrder,
            headers: {
              Authorization: userInfo.Token
            }
          })
              .then(function (res) {
                let {Status, Message, Data} = res.data;
                console.log(res.data);
                if (Status === 1) {
                  self.ordersData.OrderList = Data.OrderList
                } else {
                  self.$refs.div_AlertModalMessage.innerHTML = Message;
                  $("#div_AlertModal").modal({backdrop: "static"});
                }
              })
              .catch(function (error) {
                console.log(error);
              })
              .finally(function (res) {
                self.loadingShow = false;
              });
        },*/
        /*closeFilterPanel() {
          let self = this;
          self.isOpenFilterPanel = !self.isOpenFilterPanel;
          self.$refs.a_CloseFilterPanel.innerText = self.isOpenFilterPanel === true ? "بستن" : "نمایش";
        },*/
        /*getCustomersInfo() {
          let self = this;
          let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
          self.loadingShow = true;
          axios.get("/API/V1/Customers/GetCustomers", {
            headers: {
              'Content-Type': 'application/json',
              Authorization: userInfo.Token
            }
          })
              .then(function (res) {
                let {Data, Message, Status} = res.data;
                console.log(res.data);

                if (Status === 1) {
                  self.loadingShow = false;
                  self.customers = Data.Customers;
                } else {
                  self.loadingShow = false;
                  self.$refs.div_AlertModalMessage.innerHTML = Message;
                  $("#div_AlertModal").modal({backdrop: "static"});
                }
              })
              .catch(function (error) {
                console.log(error);
                self.loadingShow = false;
              })
              .finally(function (res) {
                self.loadingShow = false;
              });
        },*/
        /*removeTestReport(itemId) {
          let self = this;
          let userInfo = JSON.parse(localStorage.getItem("UserInfo"));
          self.loadingShow = true;
          self.uploadTestFile.ItemId = itemId;
          axios.post("/API/V1/Orders/RemoveTestReport", self.uploadTestFile, {
            headers: {
              'Content-Type': 'application/json',
              Authorization: userInfo.Token
            }
          })
              .then(function (res) {
                let {Data, Message, Status} = res.data;
                console.log(Data);

                if (Status === 1) {
                  self.loadingShow = false;
                  const itemToUpdate = self.pendingOrderData.PendingOrderList.find(item => item._id === Data.ItemId);
                  if (itemToUpdate) {
                    itemToUpdate.TestReport = null;
                    itemToUpdate.UpdatedAt = Data.UpdatedAt
                  }
                  self.$toast.open({
                    position: "bottom-right",
                    message: Message,
                    type: "success",
                    duration: 5000
                  });
                } else {
                  self.loadingShow = false;
                  self.$refs.div_AlertModalMessage.innerHTML = Message;
                  $("#div_AlertModal").modal({backdrop: "static"});
                }
              })
              .catch(function (error) {
                console.log(error);
                self.loadingShow = false;
              })
              .finally(function (res) {
                self.loadingShow = false;
              });
        },*/
      },
  created() {
    let self = this;
    self.getScores();
    // self.getOrders();
    // this.$refs.BreadCrumbTitle.innerText = "کارتابل ارسال محموله";
    // this.getCustomersInfo();
    // $("#div_EditShipmentModal").modal("show");
  },
  mounted() {
    // $("#div_EditShipmentModal").modal("show");
  },
  computed: {
    /*completeAbandonButtonVisible() {
      return !["2","3","4"].includes(this.shipment?.OrderStatus);
    },
    cancelOrderItemsButtonVisible() {
      return !this.shipment?.PendingOrder?.every(order => ["2", "3", "4"].includes(order.Status));
    }*/
  },
  watch: {
    /*pageSize: function (val) {
      this.getInstallments(this.pageIndex, this.pageSize);
    },*/
    /*"filterPendingOrders.VehicleId": function (newValue, oldValue) {
      this.order.VehicleId = newValue;
    },
    "filterPendingOrders.SupplierId": function (newValue, oldValue) {
      this.order.SupplierId = newValue;
    },
    "filterPendingOrders.WarehouseId": function (newValue, oldValue) {
      this.order.WarehouseId = newValue;
    },
    "filterPendingOrders.CustomerId": function (newValue, oldValue) {
      this.order.CustomerId = newValue;
      let customerFilter = this.customers.filter(item => item._id === newValue);
      console.log(customerFilter);
      if (customerFilter !== null && customerFilter !== undefined && customerFilter.length > 0) {
        this.vehicleList = customerFilter[0].VehiclesList;
        this.warehouseList = customerFilter[0].WarehouseList;
      }
    },
    "newShipment.CustomerId": function (newValue, oldValue) {
      let customerFilter = this.customers.filter(item => item._id === newValue);
      console.log(customerFilter);
      if (customerFilter !== null && customerFilter !== undefined && customerFilter.length > 0) {
        this.vehicleList = customerFilter[0].VehiclesList;
        this.warehouseList = customerFilter[0].WarehouseList;
      }
    },
    "panelActive": function (newValue, oldValue) {
      if (newValue === "LogisticsDashboard") {
        this.$refs.BreadCrumbTitle.innerText = "حمل و نقل";
        this.getOrdersNotInWaybills();
      } else if (newValue === "InspectorsDashboard") {
        this.$refs.BreadCrumbTitle.innerText = "بازرسی";
      } else if (newValue === "OrderingDashboard") {
        this.$refs.BreadCrumbTitle.innerText = "سفارش گذاری";
        this.getCustomersInfo();
      } else if (newValue === "ProductionPlanningDashboard") {
        this.$refs.BreadCrumbTitle.innerText = "برنامه ریزی تولید";
      } else if (newValue === "ShipmentDashboard") {
        this.$refs.BreadCrumbTitle.innerText = "کارتابل ارسال محموله";
        this.getCustomersInfo();
      }
    },*/
    /*"filterWaybill.CustomerId": function (newValue, oldValue) {
      this.order.CustomerId = newValue;
      let customerFilter = this.customers.filter(item => item._id === newValue);
      if (customerFilter !== null && customerFilter !== undefined && customerFilter.length > 0) {
        this.warehouseList = customerFilter[0].WarehouseList;
      }
    },*/
    /*"newShipment.CustomerId": function (newValue, oldValue) {
      let customerFilter = this.customers.filter(item => item._id === newValue);
      console.log(customerFilter);
      if (customerFilter !== null && customerFilter !== undefined && customerFilter.length > 0) {
        this.vehicleList = customerFilter[0].VehiclesList;
        this.warehouseList = customerFilter[0].WarehouseList;
      }
    },
    "filterPendingOrders.CustomerId": function (newValue, oldValue) {
      this.order.CustomerId = newValue;
      let customerFilter = this.customers.filter(item => item._id === newValue);
      console.log(customerFilter);
      if (customerFilter !== null && customerFilter !== undefined && customerFilter.length > 0) {
        this.vehicleList = customerFilter[0].VehiclesList;
        this.warehouseList = customerFilter[0].WarehouseList;
      }
    },
    "filterPendingOrders.VehicleId": function (newValue, oldValue) {
      this.order.VehicleId = newValue;
    },
    "filterPendingOrders.SupplierId": function (newValue, oldValue) {
      this.order.SupplierId = newValue;
    },
    "filterPendingOrders.WarehouseId": function (newValue, oldValue) {
      this.order.WarehouseId = newValue;
    },*/


  },
  components: {
    simplebar, 'paginate': Paginate, datePicker: VuePersianDatetimePicker,
  }
};
</script>

<style>
.vs__search::placeholder,
.vs__dropdown-toggle,
.vs__dropdown-menu {
  margin-bottom: 5px;
  text-transform: lowercase;
  font-variant: small-caps;
  text-align: right !important;
  direction: rtl !important;
  padding: 2px;
}

.text-right {
  direction: rtl !important;
  text-align: right !important;
}

.reset {
  all: revert;
}

.vpd-icon-btn {
  margin-bottom: 0px !important;
}

.mp-custom-input-text {
  font-size: 25px;
  direction: ltr;
  text-align: left;
}

.table-responsive {
  overflow-x: auto;
}

.table td, .table th {
  white-space: nowrap;
  /*min-height: 50 px;*/
}

th {
  font-weight: initial !important;
}

.highlight {
  background-color: #B2FF59;
}

.bg-white {
  color: initial;
}

.disabled-row {
  background-color: #f0f0f0;
  color: #919090;
  pointer-events: none;
}

</style>
